import React from "react"
import PropTypes from "prop-types"
import { usePermissions } from "hooks/usePermissions"

const PermissionGate = ({
  module,
  action,
  screen,
  checks,
  requireAll = false,
  fallback = null,
  children
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions, hasModuleAccess, hasFullAccessFlag } = usePermissions()

  if (hasFullAccessFlag) {
    return <>{children}</>
  }

  let hasAccess = false

  if (checks && Array.isArray(checks) && checks.length > 0) {
    hasAccess = requireAll ? hasAllPermissions(checks) : hasAnyPermission(checks)
  } else if (module && action) {
    hasAccess = hasPermission(module, action, screen)
  } else if (module && !action) {
    hasAccess = hasModuleAccess(module, screen)
  }

  return hasAccess ? <>{children}</> : <>{fallback}</>
}

PermissionGate.propTypes = {
  module: PropTypes.string,
  action: PropTypes.string,
  screen: PropTypes.string,
  checks: PropTypes.arrayOf(
    PropTypes.shape({
      module: PropTypes.string.isRequired,
      action: PropTypes.string.isRequired,
      screen: PropTypes.string
    })
  ),
  requireAll: PropTypes.bool,
  fallback: PropTypes.node,
  children: PropTypes.node.isRequired
}

export default PermissionGate
